import React from 'react';
const ContainerNarrow = ({ children, classNames }) => {
    return (React.createElement("div", { className: `@container max-w-[1390px] xl-plus:mx-auto mx-5 md:mx-10 lg:mx-[90px] md:py-[100px] py-[60px] ${classNames}` }, children));
};
export default ContainerNarrow;
